import Vue from 'vue'

/**
 *获取门列表
 */
export const findDoorByPage = params => {
  return Vue.fetch.post('/apiv1/acc/accDoor/findDoorByPage', params)
}

// 查询门禁时间段
export const findAccTimezoneByPage = params => {
  return Vue.fetch.post('/apiv1/acc/accTimezone/findAccTimezoneByPage', params)
}

// 查询时间段详情
export const findAccTimezoneDetailByTimezoneNum = params => {
  return Vue.fetch.post(
    '/apiv1/acc/accTimezone/findAccTimezoneDetailByTimezoneNum',
    params
  )
}

// 查询权限组列表
export const findLevelByPage = params => {
  return Vue.fetch.post('/apiv1/acc/accLevel/findLevelByPage', params)
}

// 查询权限组详情
export const findLevelDetailByGroupNum = params => {
  return Vue.fetch.post('/apiv1/acc/accLevel/findLevelDetailByGroupNum', params)
}

export const findAccAuthorityDevice = params => {
  return Vue.fetch.post('/apiv1/hr/employee/findAccAuthorityDevice', params)
}

export const findUserBindDeviceLevel = params => {
  return Vue.fetch.post('/apiv1/acc/accLevel/findUserBindDeviceLevel', params)
}



// WEBPACK FOOTER //
// ./src/services/accManager.js